module.exports = __webpack_public_path__ + "fonts/MullerHeavyItalic.3e850063.ttf";